"use client";
import { createLogAdapter } from "@/lib/logger/console-adapter";

import type React from "react";

import { SWRConfig } from "swr";

const uiLog = createLogAdapter("components/providers/swr-provider.tsx");

interface SWRProviderProps {
	children: React.ReactNode;
}

export function SWRProvider({ children }: SWRProviderProps) {
	return (
		<SWRConfig
			value={{
				refreshInterval: 0, // Disable global refresh, each hook will set its own
				dedupingInterval: 2000, // Prevent duplicate requests within 2 seconds
				revalidateOnFocus: false, // Disable revalidation on window focus
				revalidateOnReconnect: true, // Revalidate when network reconnects
				errorRetryCount: 3, // Retry failed requests 3 times
				errorRetryInterval: 1000, // Wait 1 second between retries
				onError: (error) => {
					uiLog.error("SWR Error:", error);
				},
			}}
		>
			{children}
		</SWRConfig>
	);
}
